import ReactDOM from "react-dom";

const Backdrop = (props) => {
    return <div className="fixed top-0 left-0 w-full h-screen z-10 bg-neutral/75" onClick={props.onConfirm} />;
};

const ModalOverlay = (props) => {
    let color = 'bg-primary';
    if (props.type == 'error') {
        color = 'bg-red-600';
    } else if (props.type == 'warning') {
        color = 'bg-orange-500';
    } else if (props.type == 'success') {
        color = 'bg-green-500';
    }
    return (
        <div className={`bg-white ${props.width} ${props.height} text-black overflow-y-auto fixed left-[calc(50%-20rem)] md:left-1/2 md:-translate-x-1/2 top-[30vh] z-50 text-center items-center justify-center rounded-xl md:w-[min(50%, 500px)]`} >
            <h2 className={`${color} p-4 rounded-t-xl m-0 text-white font-bold`}>{props.title}</h2>
            <div className="p-4">
                <div>{props.message}</div>
            </div>
            <div className="p-4 flex justify-center">
                <button className="px-6 py-2 border-2 border-black hover:bg-neutral duration-150" onClick={props.onConfirm}>{props.text}</button>
            </div>
        </div>
    );
};

const CustomModal = (props) => {
    return (
        <>
            {ReactDOM.createPortal(
                <Backdrop onConfirm={props.onConfirm} />,
                document.getElementById("backdrop-root")
            )}
            {ReactDOM.createPortal(
                <ModalOverlay
                    onConfirm={props.onConfirm}
                    title={props.title}
                    message={props.message}
                    type={props.type}
                    width={props.width ? props.width : 'w-[40rem]'}
                    height={props.height ? props.height : 'h-fit'}
                    text={props.text ? props.text : 'Okay'}
                />,
                document.getElementById("overlay-root")
            )}
        </>
    );
};

export default CustomModal;